import React from 'react';

import { useGraphQLQuery } from '@betterment/js-runtime';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { EnvelopeAccountRecurringTransactionConfigsDocument } from './graphql/envelopeAccountRecurringTransactionConfigs.generated';

import { RecurringTransactionsCardView } from '../../../Shared/components-v2/recurring-transactions-card-view/RecurringTransactionsCardView';

export const RecurringTransactionsCardController: React.FC = () => {
  const accountId = useRequiredParam('accountId');
  const { data } = useGraphQLQuery(EnvelopeAccountRecurringTransactionConfigsDocument, {
    variables: { id: accountId },
    throwOnError: true,
  });

  if (!data) return <CardLoader />;
  if (!('recurringTransactionConfigs' in data.account)) return null;

  const { account } = data;

  if (account.__typename === 'CashAccount') {
    const isWithdrawal = (sourceLegacySubAccountId: number) => {
      return account.legacySubAccountId === sourceLegacySubAccountId;
    };

    return (
      <RecurringTransactionsCardView
        recurringTransactionConfigs={account.recurringTransactionConfigs}
        isWithdrawal={isWithdrawal}
        subAccountId={account.legacySubAccountId.toString()}
      />
    );
  }

  const isWithdrawal = (sourceLegacySubAccountId: number) => {
    return !!account.subAccounts.find(subAccount => subAccount.legacySubAccountId === sourceLegacySubAccountId);
  };

  const hasNoConfigs = [...account.recurringTransactionConfigs, ...account.payrollContributionConfigs].length === 0;
  if (hasNoConfigs && account.subAccounts.every(a => !a.isRecurringDepositEligible)) {
    return null;
  }

  return (
    <RecurringTransactionsCardView
      recurringTransactionConfigs={account.recurringTransactionConfigs}
      isWithdrawal={isWithdrawal}
      payrollContributionConfigs={account.payrollContributionConfigs}
      subAccountId={account.subAccounts[0].legacySubAccountId.toString()}
    />
  );
};

export const RecurringTransactionsCard: React.FC = () => (
  <ErrorBoundary fallbackType="none">
    <RecurringTransactionsCardController />
  </ErrorBoundary>
);
